export default require('./components/FlipCard');


// WEBPACK FOOTER //
// ./src/Scripts/react-flipcard/lib/main.js